import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class TaskStatusService {
  url = '/api/task-statuses';

  constructor(private http: HttpClient) {}

  get(): Promise<any> {
    return this.http.get(`${this.url}`).toPromise().catch();
  }
}
